import { TrendingDown, TrendingUp, BarChart3 } from 'lucide-react';
import { useLocale } from '../../contexts/LocaleContext';
import '../AllCss/GoodDealBadge.css';

function GoodDealBadge({ insight, variant = 'card' }) {
  const { t } = useLocale();
  if (!insight) return null;

  const label = (key, fallback) => {
    const v = t(`market.${key}`);
    return v && !v.startsWith('market.') ? v : fallback;
  };

  if (insight.isGoodDeal) {
    return (
      <span className={`good-deal-badge good-deal-badge--deal good-deal-badge--${variant}`} title={label('goodDealTitle', 'Below similar listings')}>
        <TrendingDown size={14} aria-hidden />
        {label('goodDeal', 'Good deal')}
        {variant === 'detail' && insight.savings > 0 && (
          <span className="good-deal-badge-sub">
            {`~$${insight.savings.toLocaleString()} ${label('belowPeers', 'below similar')}`}
          </span>
        )}
      </span>
    );
  }

  if (insight.isAboveMarket) {
    return (
      <span className={`good-deal-badge good-deal-badge--above good-deal-badge--${variant}`}>
        <TrendingUp size={14} aria-hidden />
        {label('aboveMarket', 'Above market')}
      </span>
    );
  }

  if (variant === 'detail') {
    return (
      <span className={`good-deal-badge good-deal-badge--fair good-deal-badge--${variant}`}>
        <BarChart3 size={14} aria-hidden />
        {label('fairPrice', 'Fair vs market')}
        <span className="good-deal-badge-sub">
          {`${label('vs', 'vs')} ${insight.peerCount} ${label('similar', 'similar')}`}
        </span>
      </span>
    );
  }

  return null;
}

export default GoodDealBadge;
